
import Strongbox2 from "../../../assets/filled/Strongbox2.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Strongbox2Icon({ className, dataTestid = "Strongbox2Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Strongbox2 data-testid={dataTestid} className={classes} {...rest} />
  );
}
